import SiteContext from "../context/SiteContext";
import {useContext} from "react";
const IndustryNavigator = () => {

    const {industries, currentIndustryIndex, changeCurrentIndustry} = useContext(SiteContext);

    const currentIndustry = industries[currentIndustryIndex].id;

    function onIndustryClick(e) {
        changeCurrentIndustry(e.currentTarget.getAttribute("data-id"));
    }

    return (
        <nav className="industry-navigator">
            {industries.map((industry, index) => (
                <button className={industry.id === currentIndustry ? 'industry-navigator-item selected' : 'industry-navigator-item'} data-id={index} onClick={onIndustryClick} key={index.toString()}>
                    <span className="industry-navigator-item-label">{industry.title}</span>
                </button>
            ))}
        </nav>
    );
};

export default IndustryNavigator;
